import React from 'react';
import { Row, Col, Button, TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import {inject, observer} from "mobx-react";
import CardBooking from "./CardBooking";
import CardNotaFiscal from "./CardNotaFiscal";
import classnames from 'classnames';
import _ from "lodash";
import { IconeGenerico, IconeCarregar } from '../../../../comum/components/Icones';

@inject("store")
@observer
export default class ContainerCheio extends React.Component {
    constructor(props) {
        super(props);
        this.parametrosStore = this.props.store.parametrosStore;
        
        this.agendamentoController = this.props.agendamentoController;

        this.isSSA = !process.env.rig;
        this.isRIG = process.env.rig;
        this.state = {
            atualizado: true
        }
    };

    componentDidMount = () => {
        if (!this.agendamentoController.isEditar)
        {   
            if (!this.agendamentoController.dadosAgendamento.listaBookings)
                this.agendamentoController.abrirInserirNovoBooking();
        }
    }

    refresh = () => {
        this.setState({ atualizado: false });
        setTimeout(function() {
            this.setState({ atualizado: true })
        }.bind(this), 1);
    };


    listaBooking() {
        if (this.agendamentoController.atualizaBookings)
            if (this.agendamentoController.dadosAgendamento.listaBookings) {
               return this.agendamentoController.dadosAgendamento.listaBookings.map((book, x) => (
                    <Row key={x}>
                        <Col xl={12}>
                            <CardBooking
                                index={x}
                                booking={ book }
                                agendamentoController={this.agendamentoController}
                                isEditar={ this.agendamentoController.isEditar }
                                dado={ `listaBookings[${x}]` }
                                operacoes={ this.agendamentoController.operacoes }
                                tiposMercadoria={ this.agendamentoController.tiposMercadoria }
                                remover={ this.agendamentoController.removerBooking }
                                adicionarNovoContainer={ this.agendamentoController.abrirInserirNovoBookingContainer }
                                duplicarContainer={ this.agendamentoController.duplicarContainer }
                                removerContainer={ this.agendamentoController.removerBookingContainer }
                                duplicar={ this.agendamentoController.duplicarBooking }
                                adicionarLacre={ this.agendamentoController.adicionarNovoBookingContainerLacre }
                                removerLacre={ this.agendamentoController.removerBookingContainerLacre }
                                atualizaLacres={ this.agendamentoController.atualizaLacres }
                                tipoAgenda={this.agendamentoController.tipoAgendaAtivo}
                                terminal = {this.agendamentoController.terminal}
                                salvo={ this.props.salvo } 
                                ncmAtivo={ this.agendamentoController.notaFiscalNObrigatoria }
                                setDado={ this.agendamentoController.setDadosAgendamento }
                                setDadosAgendamentoSemPensar={ this.agendamentoController.setDadosAgendamentoSemPensar }
                                validacaoCampos={this.agendamentoController.setValidacao}
                                setDadosLacre={ this.agendamentoController.setDadosLacre } 
                                codigoBooking = {this.props.codigoBooking}
                                onBlurEvent = {this.agendamentoController.handleBlurBooking}
                                onBlurEventContainer = {this.agendamentoController.handleBlurContainer}
                                atualizarMensagemContainerNotas = {this.agendamentoController.validarContainerBookingNotas}
                                blurStatus = {this.agendamentoController.blurStatus}
                                dadosMercadoria = {this.agendamentoController.dadosMercadoria}
                                montarSelectContainer = {this.agendamentoController.montarSelectOpContainer}
                                collapseBookings = {this.agendamentoController.collapseBookings}
                                setStatusSalvo = {this.props.setStatusSalvo}
                            />
                        </Col>
                    </Row>))
            } else return null;
    };

    listaNotaFiscal() {
        if(this.agendamentoController.atualizaNotasFiscais) {
            if (this.agendamentoController.dadosNotaFiscal.listaNf) {
                return this.agendamentoController.dadosNotaFiscal.listaNf.map((ntFiscal, x) => (
                    <Row key={x}>
                        <Col xl={12}>
                            <CardNotaFiscal
                                bookings={this.agendamentoController.dadosAgendamento}
                                agendamentoController={this.agendamentoController}
                                index={x}
                                isEditar={ this.agendamentoController.isEditar }
                                ntFiscal={ntFiscal}
                                dado={`listaNf[${x}]`}
                                remover={this.agendamentoController.removerNotaFiscal}
                                adicionarNovoContainer={this.agendamentoController.abrirInserirNovoNotaFiscalContainer}
                                removerContainer={(value) => this.agendamentoController.removerNotaFiscalContainer(x, value)}
                                adicionarNovoNCM={this.agendamentoController.abrirInserirNovoNotaFiscalNCM}
                                removerNCM={(value) => this.agendamentoController.removerNotaFiscalNCM(x, value)}
                                setDado={this.agendamentoController.setDadosNotaFiscal}
                                setDadoDireto={this.agendamentoController.setDadosNotaFiscalSemPensar}
                                atualizaDados={this.agendamentoController.atualizaNotas}
                                atualizaContainers={this.agendamentoController.atualizaNotasFiscaisContainer}
                                isRIG={this.isRIG}
                                isSSA={this.isSSA}
                                setCamposContainer={this.agendamentoController.setCamposContainerNotaFiscal}
                                listaContainersSelect={this.agendamentoController.listaContainersOptions}
                                containersSelecionados={this.agendamentoController.containersSelecionados}
                                salvo={this.props.salvo}
                                carregarContainersSelecionados={this.agendamentoController.formatarContainersSelecionado}
                                setBagagemFlag = {this.agendamentoController.carregaCamposObrigatoriosNotasFiscais}
                                setStatusSalvo = {this.props.setStatusSalvo}
                                collapseNotaFiscal = {this.agendamentoController.collapseNotaFiscal}
                                transportadorasNotaFiscal = {this.agendamentoController.transportadoras}
                            />
                        </Col>
                    </Row>))
            } else return null;
        }
    };
    
    handleMudaAba = (aba) => {
        this.agendamentoController.mudaAbaEntrada(aba);
        if (aba==="1") {
            this.setState({atualizado : false})
        }
        
        //Validar container do booking com o da nota
        if (aba==="0" &&
            this.agendamentoController.dadosAgendamento.listaBookings && 
            this.agendamentoController.dadosAgendamento.listaBookings.length > 0 && 
            this.agendamentoController.dadosNotaFiscal.listaNf && 
            this.agendamentoController.dadosNotaFiscal.listaNf.length > 0)
        {
            this.props.agendamentoController.validarContainerBookingNotas();
        }
    }

    excluiDadosNota = () => {
        setTimeout(() => {
            this.setState({atualizado : true}); 
        }, 1000);
        return <div />
    }

    navsBooking() {
        return <div>
            <Row>
                <Col xs={12} sm={8} md={6} >
                    <Nav tabs>
                        {["EUA"].indexOf(this.agendamentoController.tipoAgendaAtivo.codIdentificador) === -1 ? 
                        <NavItem>
                            <NavLink className={ classnames({ active: this.agendamentoController.abaEntradaAtiva === '0' }) } onClick={() => { this.handleMudaAba('0'); }} >
                                Bookings
                            </NavLink>
                        </NavItem>
                        : ""
                        }
                        {/* Funcionalidade de Nota Fiscal removida de Rio Grande após go live */}
                        {!process.env.rig && ["ECV", "ECE", "ECVB", "EUA", "23ECV"].indexOf(this.agendamentoController.tipoAgendaAtivo.codIdentificador) === -1 ? 
                        <NavItem>
                            <NavLink className={ classnames({ active: this.agendamentoController.abaEntradaAtiva === '1' }) } onClick={() => { this.handleMudaAba('1'); }} >
                                Nota Fiscal
                            </NavLink>
                        </NavItem>
                        : ""
                        }
                    </Nav>
                </Col>
                <Col xs={12} sm={4} md={6} >
                    {this.agendamentoController.abaEntradaAtiva === '0' 
                        ?   
                            ["EUA"].indexOf(this.agendamentoController.tipoAgendaAtivo.codIdentificador) === -1 && !this.agendamentoController.isEditar ? 
                                <React.Fragment>
                                    <Button onClick={ this.agendamentoController.abrirInserirNovoBooking } className="btn-com-bordas-primary">Novo Booking</Button>
                                </React.Fragment>
                            : ""
                        :   <React.Fragment>
                                <Button onClick={ this.agendamentoController.inserirNotasAssociadas } className="btn-com-bordas-primary">
                                    {this.agendamentoController.loadNotasAssociadas ?
                                    <IconeCarregar className="mr-1"/> : 
                                    <IconeGenerico icone="arrow-down" className="mr-1"/>} 
                                    Notas Associadas
                                </Button>
                                <Button onClick={ this.agendamentoController.abrirInserirNovaNotaFiscal } className="btn-com-bordas-primary">Nova Nota Fiscal</Button>
                                <Button onClick={ this.agendamentoController.abrirInserirXMLNotaFiscal } className="btn-com-bordas-cinza">Inserir XML</Button>
                            </React.Fragment>
                    }
                </Col>
            </Row>
            <TabContent activeTab={ this.agendamentoController.abaEntradaAtiva }>
                <TabPane tabId="0">
                    { this.listaBooking() }
                </TabPane>
                <TabPane tabId="1">
                    { !this.state.atualizado ? this.excluiDadosNota() : this.listaNotaFiscal() }
                </TabPane>
            </TabContent>
        </div>
    };

    render() {
    	return (
            <div>
                { this.navsBooking() }
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/modules/agendamento/containers-cadastrar/entrada-containers/components/ContainerCheio.js